module.exports = __webpack_public_path__ + "media/images/pc/articles/report_temp_01-6098cd308f13811f0337944981da9d37.webp";